import React from "react";

export default function AceBackground() {
  return (
    <div className="ac-bg-root" aria-hidden="true">
      <div className="ac-blob ac-blob-1" />
      <div className="ac-blob ac-blob-2" />
      <div className="ac-blob ac-blob-3" />
    </div>
  );
}